import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="py-12" style={{ backgroundColor: '#f5f4f0' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Image Gallery */}
        <div className="mb-12">
          <div className="text-center mb-8">
            <img 
              src="https://customer-assets.emergentagent.com/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/scwl4e2h_Warm%20Linen.png" 
              alt="Soul Bridge Doula" 
              className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg h-auto mx-auto"
            />
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {/* 1. Soup image */}
            <div className="overflow-hidden rounded-lg group">
              <img
                src="https://customer-assets.emergentagent.com/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/pgw36ugy_Care_Soup.webp"
                alt="Nurturing care"
                className="w-full h-48 object-cover rounded-lg transform transition-transform duration-500 group-hover:scale-110"
              />
            </div>
            {/* 2. Becoming_Breastfeeding.jpg */}
            <div className="overflow-hidden rounded-lg group">
              <img
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/d9bsamyo_Becoming_Breastfeeding.webp"
                alt="Breastfeeding journey"
                className="w-full h-48 object-cover rounded-lg transform transition-transform duration-500 group-hover:scale-110"
              />
            </div>
            {/* 3. drums.JPG */}
            <div className="overflow-hidden rounded-lg group">
              <img
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/nrcsazv0_drums.JPG"
                alt="Celebration and ritual"
                className="w-full h-48 object-cover rounded-lg transform transition-transform duration-500 group-hover:scale-110"
              />
            </div>
            {/* 4. Belonging_Family.jpg */}
            <div className="overflow-hidden rounded-lg group">
              <img
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/z8pavx5a_Belonging_Family.webp"
                alt="Family togetherness"
                className="w-full h-48 object-cover rounded-lg transform transition-transform duration-500 group-hover:scale-110"
              />
            </div>
            {/* 5. Wonder_crystal.jpg */}
            <div className="overflow-hidden rounded-lg group">
              <img
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/3hp51htu_Wonder_crystal.webp"
                alt="Wonder and connection"
                className="w-full h-48 object-cover rounded-lg transform transition-transform duration-500 group-hover:scale-110"
              />
            </div>
            {/* 6. mulher ao sol.jpg */}
            <div className="overflow-hidden rounded-lg group">
              <img
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/t511kwcu_sol.webp"
                alt="Light and warmth"
                className="w-full h-48 object-cover rounded-lg transform transition-transform duration-500 group-hover:scale-110"
              />
            </div>
          </div>
        </div>

        {/* Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
          {/* Info */}
          <div>
            <h3 className="text-sm font-semibold tracking-wider mb-4" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>INFO</h3>
            <Link to="/privacy" className="block text-sm text-gray-600 hover:text-[#815863] mb-2" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              Privacy Policy
            </Link>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold tracking-wider mb-4" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>CONTACT</h3>
            <a
              href="mailto:contact@soulbridgedoula.co.uk"
              className="block text-sm text-gray-600 hover:text-[#815863] mb-2"
              style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}
            >
              contact@soulbridgedoula.co.uk
            </a>
            <Link to="/contact" className="block text-sm text-gray-600 hover:text-[#815863] mb-4" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              Book a Connection Call
            </Link>
            <div className="flex justify-center md:justify-start space-x-4 mt-4">
              <a 
                href="https://www.instagram.com/soulbridge.doula" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-600 hover:text-[#815863] transition-colors" 
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Explore */}
          <div>
            <h3 className="text-sm font-semibold tracking-wider mb-4" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>EXPLORE</h3>
            <Link to="/" className="block text-sm text-gray-600 hover:text-[#815863] mb-2" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              Home
            </Link>
            <Link to="/services" className="block text-sm text-gray-600 hover:text-[#815863] mb-2" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              Support
            </Link>
            <Link to="/about" className="block text-sm text-gray-600 hover:text-[#815863] mb-2" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              My Story
            </Link>
            <Link to="/faqs" className="block text-sm text-gray-600 hover:text-[#815863] mb-2" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              Your Questions
            </Link>
            <Link to="/contact" className="block text-sm text-gray-600 hover:text-[#815863] mb-2" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              Lets Connect
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;